export default "__VITE_ASSET__DTb6GKy7__"